var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSidebarAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66602C5.40768 1.66602 1.66602 5.40768 1.66602 9.99935C1.66602 14.591 5.40768 18.3327 9.99935 18.3327C14.591 18.3327 18.3327 14.591 18.3327 9.99935C18.3327 5.40768 14.591 1.66602 9.99935 1.66602ZM13.6243 12.9743C13.5077 13.1743 13.2993 13.2827 13.0827 13.2827C12.9743 13.2827 12.866 13.2577 12.766 13.191L10.1827 11.6493C9.54102 11.266 9.06602 10.4243 9.06602 9.68268V6.26602C9.06602 5.92435 9.34935 5.64102 9.69102 5.64102C10.0327 5.64102 10.316 5.92435 10.316 6.26602V9.68268C10.316 9.98268 10.566 10.4243 10.8243 10.5743L13.4077 12.116C13.7077 12.291 13.8077 12.6743 13.6243 12.9743Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarAvailability);
export default __webpack_public_path__ + "static/media/ic_sidebar_availability.073d73f5d51f0ebcb1f87629aa695c70.svg";
export { ForwardRef as ReactComponent };